import { BillingCycle } from '~/types/models';

export const bonjoroBillingCycleToPlandalfBillingCycleCode = (
  billingCycle: BillingCycle
) => {
  // monthly
  if (billingCycle === BillingCycle.Monthly) return 'P1M';

  // yearly
  return 'P1Y';
};
